var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-table',{attrs:{"data":_vm.tableData,"columns":_vm.columns}})
}
var staticRenderFns = []

export { render, staticRenderFns }